import React from 'react';
import { createComponent } from '@lit-labs/react';

import Dsy from './dsyui';

const LitComp = Dsy.components.DsyBreadcrumbs;

export const DsyBreadcrumbs = createComponent(
  React,
  'dsy-breadcrumbs',
  LitComp,
  {},
);

export default DsyBreadcrumbs;
